import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CODE_EXPORT } from 'drapcode-constant';
import { Link } from 'react-router-dom';
import * as actions from '../redux/actions';
import CodeExportForm from './CodeExportForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CardTitleHeader from '../../../common/ui/CardTitleHeader';
import ExportRequestList from './ExportRequestList';
import PermissionDenied from '../../../common/PermissionDenied';

export class CodeExportMain extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions, projectId, version } = this.props;
    actions.loadPermissionFlags({ projectId });
    actions.loadProjectDepSetting({ projectId, version });
    actions.loadCodeExportRequestList({ projectId, version });
    actions.listDeploymentSetting({ projectId });
    actions.listGithubExportList({ projectId });
  }

  showCodeExportTable = () => {
    const { actions, deploymentSetting, projectId, version } = this.props;
    const {
      projectDetail,
      exportRequestList,
      exportProjectCodePending,
      permissionFlags,
      codeDownloadHistories,
      githubExportList,
      settings,
    } = deploymentSetting;
    const { enableCodeExport } = projectDetail;
    if (!enableCodeExport || enableCodeExport === 'undefined') {
      return '';
    }

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-violet">
          <i className={`wb ${drapcodeIcon('list')}`}></i>
        </div>
        <div className="card-content">
          <CardTitleHeader title="Export Request List" />
          <div className="col-md-12 col-lg-12 table-responsive">
            <ExportRequestList
              projectId={projectId}
              exportRequestList={exportRequestList}
              githubExportList={githubExportList}
              settings={settings}
              exportProjectCodePending={exportProjectCodePending}
              codeDownloadHistories={codeDownloadHistories}
              deleteExportRequest={actions.deleteExportRequest}
              loadDownloadCodeHistory={actions.loadDownloadCodeHistory}
              pushToGitHub={actions.pushToGitHub}
              deleteFlag={permissionsArray.includes(CODE_EXPORT)}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { actions, deploymentSetting, projectId, version } = this.props;
    const {
      projectDetail,
      exportRequestList,
      exportProjectCodePending,
      permissionFlags,
      settings,
      githubExportList,
    } = deploymentSetting;
    if (!projectDetail) {
      return '';
    }
    return (
      <>
        <div className="card">
          <div className="card-header card-header-icon" data-background-color="drapcode-violet">
            <i className={`wb ${drapcodeIcon('codeExport')}`}></i>
          </div>
          <div className="card-content">
            <div className="card-title-header">
              <h4 className="card-title">Code Export (Beta)</h4>
            </div>

            <CodeExportForm
              projectDetail={projectDetail}
              projectId={projectId}
              version={version}
              settings={settings}
              githubExportList={githubExportList}
              exportProjectCode={actions.exportProjectCode}
            />
          </div>
        </div>
        {this.showCodeExportTable()}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CodeExportMain);
